import React from 'react';
import { SunMedium, Palette, Sparkles } from 'lucide-react';
import { RangeSlider } from '../controls/RangeSlider.jsx';

export function RelightControls({
  lightColor,
  onChangeLightColor,
  lightIntensity,
  onChangeLightIntensity,
  lightDirection,
  onChangeLightDirection,
  onTriggerRelight,
  isProcessing
}) {
  const COLOR_PALETTES = [
    { id: '#f59e0b', label: 'Golden Hour' },
    { id: '#06b6d4', label: 'Cyberpunk Cyan' },
    { id: '#ec4899', label: 'Neon Magenta' },
    { id: '#3b82f6', label: 'Moonlight Blue' },
    { id: '#ffffff', label: 'Studio White' }
  ];

  const DIRECTIONS = [
    { id: 'left', label: 'Luz Lateral Izq.' },
    { id: 'top', label: 'Cenital Superior' },
    { id: 'right', label: 'Luz Lateral Der.' },
    { id: 'back', label: 'Contraluz / Rim Light' }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{
        padding: '12px',
        background: 'rgba(251,191,36,0.06)',
        borderRadius: '10px',
        border: '1px solid rgba(251,191,36,0.2)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#fbbf24', fontSize: '12px', fontWeight: 700, marginBottom: '4px' }}>
          <SunMedium size={14} /> Relight Studio Engine
        </div>
        <p style={{ fontSize: '11px', color: '#94a3b8', lineHeight: '1.4' }}>
          Modifica el esquema de iluminación, temperatura de color y dirección del foco fotográfico de tu avatar sin perder identidad.
        </p>
      </div>

      <div>
        <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '8px' }}>
          <Palette size={12} color="#fbbf24" /> Ambiente / Temperatura de Luz
        </label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px' }}>
          {COLOR_PALETTES.map((c) => {
            const isSelected = lightColor === c.id;
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => onChangeLightColor(c.id)}
                title={c.label}
                style={{
                  height: '32px',
                  borderRadius: '8px',
                  background: c.id,
                  border: isSelected ? '2px solid #ffffff' : '1px solid rgba(255,255,255,0.1)',
                  cursor: 'pointer',
                  boxShadow: isSelected ? `0 0 14px ${c.id}` : 'none',
                  transition: 'all 0.15s ease'
                }}
              />
            );
          })}
        </div>
      </div>

      <div>
        <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'block', marginBottom: '8px' }}>
          Dirección del Foco
        </label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px' }}>
          {DIRECTIONS.map((dir) => {
            const isSelected = lightDirection === dir.id;
            return (
              <button
                key={dir.id}
                type="button"
                onClick={() => onChangeLightDirection(dir.id)}
                style={{
                  padding: '8px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  background: isSelected ? 'rgba(251,191,36,0.18)' : '#141724',
                  color: isSelected ? '#fbbf24' : '#94a3b8',
                  border: isSelected ? '1px solid rgba(251,191,36,0.6)' : '1px solid rgba(255,255,255,0.06)',
                  transition: 'all 0.15s ease'
                }}
              >
                {dir.label}
              </button>
            );
          })}
        </div>
      </div>

      <RangeSlider
        label="Intensidad de Iluminación"
        value={lightIntensity}
        min={10}
        max={100}
        unit="%"
        leftHint="Suave"
        rightHint="Dramático"
        onChange={onChangeLightIntensity}
      />

      <button
        type="button"
        onClick={onTriggerRelight}
        disabled={isProcessing}
        style={{
          width: '100%',
          padding: '14px',
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          color: '#fff',
          fontWeight: 700,
          fontSize: '14px',
          border: 'none',
          cursor: isProcessing ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          boxShadow: '0 4px 20px rgba(245,158,11,0.4)',
          transition: 'all 0.2s',
          marginTop: 'auto'
        }}
      >
        <Sparkles size={16} />
        {isProcessing ? 'Re-iluminando escena...' : '⚡ Aplicar Relight en Canvas'}
      </button>
    </div>
  );
}
